import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';

import { routes } from './app.routes';
import { tokenInterceptor } from './core/interceptors/token.interceptor.fn';
// import { loadingInterceptor } from './core/interceptors/loading.interceptor.fn';
import { errorInterceptor } from './core/interceptors/error.interceptor.fn';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideHttpClient(
      withInterceptors([
        tokenInterceptor,
        // loadingInterceptor,
        errorInterceptor,
      ]),
    ),
    provideClientHydration(),
  ],
};
